export default __webpack_public_path__ + "static/media/4.d244cc25.PNG";